import React from 'react';
import FormContainerContextProvider, {
	useFormContainerContext,
} from '../../Services/FormContainerContext';
import { joinClasses } from '../../Utils/className.util';
// @ts-ignore
import styles from './FormContainer.module.scss';

interface FormContainerProps {
	children: React.ReactNode;
	name?: string;
	settings?: {
		showLine?: boolean;
		showBox?: boolean;
		style?: React.CSSProperties;
	};
	ignoreFinalName?: boolean;
	className?: string;
}

const FormContainer: React.FC<FormContainerProps> = props => {
	const {
		children,
		name,
		settings,
		ignoreFinalName = false,
		className,
	} = props;
	const { name: formContainerName } = useFormContainerContext();
	const finalName =
		formContainerName && !ignoreFinalName
			? `${formContainerName}.${name}`
			: name;

	if (!name) {
		return (
			<div
				className={joinClasses([
					settings?.showLine ? styles.showLine : '',
					settings?.showBox ? styles.showBox : '',
				])}
				style={settings?.style}>
				{children}
			</div>
		);
	}

	return (
		<FormContainerContextProvider name={finalName}>
			<div
				className={joinClasses([
					settings?.showLine ? styles.showLine : '',
					settings?.showBox ? styles.showBox : '',
					className,
				])}
				style={settings?.style}>
				{children}
			</div>
		</FormContainerContextProvider>
	);
};

export default FormContainer;
